export function moveOrderingItems(items, index, delta) {
  const source = Array.isArray(items) ? items : [];
  const destination = index + delta;
  if (index < 0 || index >= source.length || destination < 0 || destination >= source.length) {
    return source;
  }
  const next = [...source];
  [next[index], next[destination]] = [next[destination], next[index]];
  return next;
}
